import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { Typography } from '@material-ui/core'
import useTranslate from '../../i18n/useTranslate'

const useStyles = makeStyles(() => ({
    root: {
        flexGrow: 1,
    },
    tabsRoot: {
        '& .MuiTabScrollButton-root': {
            color: 'black',
        },
        '& .MuiTab-root': {
            maxWidth: 'unset',
        },
    },
    tabRoot: {
        border: '1px solid',
        borderColor: '#bfbdbd',
        borderRadius: '10px 10px 0px 0px',
        margin: '0px 1px',
        '&.Mui-selected': {
            backgroundColor: ' #db5f8e',
            color: '#fff',
            borderColor: '#db5f8e',
        },
    },
    indicatorRoot: {
        backgroundColor: 'unset',
    },
}))

export default function IconLabelTabs(props: any) {
    const classes = useStyles()
    const translate = useTranslate()
    const { onChangeTab, tabIndex = 0, tabList } = props
    const [value, setValue] = React.useState(0)

    const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
        setValue(newValue)
    }

    return (
        <Tabs
            value={tabIndex}
            onChange={(event: object, tabIndex: any) => {
                const tabSelected = tabList[tabIndex]
                onChangeTab(tabIndex, tabSelected)
            }}
            indicatorColor="secondary"
            textColor="primary"
            aria-label="icon label tabs example"
            variant="scrollable"
            scrollButtons="auto"
            classes={{
                root: classes.tabsRoot,
                indicator: classes.indicatorRoot,
            }}
        >
            {tabList.map((itm: any) => {
                return (
                    <Tab
                        className={classes.tabRoot}
                        label={
                            <Typography>
                                {translate.languageStore.currentLanguage === translate.languageKey.th
                                    ? itm.nameTH
                                    : itm.nameEN}
                            </Typography>
                        }
                    />
                )
            })}
        </Tabs>
    )
}
